import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Button from '@components/Button';
import Link from '@utility/Link';
import InViewport from '@utility/InViewport';
import Emblem from '@images/emblem.svg';
import cn from 'classnames';
import * as styles from './styles';

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      sanityFooter {
        address
        address2
        contact
        contact2
        contactEmail
        contactEmail2
        fax
        phone
        socials {
          links {
            label
            url
            _key
            _type
          }
        }
        _rawPagesLink(resolveReferences: { maxDepth: 3 })
      }
    }
  `);

  return (
    <footer className="py-24 bg-wisteria text-hotoke">
      <div className="wrapper">
        <InViewport className={styles.inner}>
          <div className="row">
            {!!data.sanityFooter.socials.links.length && (
              <div className="col-6 lg:col-3">
                <h2 className="type-4640 mb-6 lg:mb-12">Connect</h2>
                <ul className={styles.list}>
                  {data.sanityFooter.socials.links.map((link) => (
                    <li key={link._key}>
                      <Link to={link} internalExternal>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="col-12 lg:col-5 lg-down:mt-12">
              <h2 className="type-4640 mb-6 lg:mb-12">Contact</h2>
              <ul className={cn(styles.list, styles.info)}>
                <li>{data.sanityFooter.address}</li>
                <li>{data.sanityFooter.address2}</li>
                {data.sanityFooter.phone && (
                  <li>Tel. {data.sanityFooter.phone}</li>
                )}
                {data.sanityFooter.fax && (
                  <li>Fax. {data.sanityFooter.fax}</li>
                )}
                <li>
                  {data.sanityFooter.contact}&nbsp;
                  <a href={`mailto:${data.sanityFooter.contactEmail}`}>
                    {data.sanityFooter.contactEmail}
                  </a>
                </li>
                <li>
                  {data.sanityFooter.contact2}&nbsp;
                  <a href={`mailto:${data.sanityFooter.contactEmail2}`}>
                    {data.sanityFooter.contactEmail2}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-12 lg-down:hidden lg:col-4 lg-down:mt-12">
              <ul className={cn(styles.list, styles.page)}>
                {data.sanityFooter._rawPagesLink.page.map((page, index) => (
                  <li key={index}>
                    <Link to={`/${page.page.slug.current}`}>{page.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row items-end mt-12">
            <div className="col-3">
              <Emblem />
            </div>
            <div className="col-9">
              <div className="flex justify-end">
                {new Date().getFullYear()} - Vancouver Buddhist Temple
              </div>
            </div>
          </div>
        </InViewport>
      </div>
    </footer>
  );
};

export default Footer;
